import React from "react";
import PropTypes from "prop-types";
import ValidationTree
    from "../validationtree/containers/ValidationTreeContainer";
import ActiveFormStore from "data/ActiveFormStore";
import Dispatcher from "Dispatcher";
import ActiveFormActions from "data/ActiveFormActions";
import NavTabs from "lib/common/navtabs/NavTabs";
import DataDefinitionsContainer
    from "lib/dataentry/lib/datadefinition/DataDefinitionsContainer";

/*  
    AI Suggest right pane - 
    This is where the the AI Suggest gets put into the right pane and resizes based on if the section is expanded or collapsed. 
*/

import AbstractionAi
    from "lib/dataentry/lib/abstractionai/AbstractionAiContainer";
import NavigatorStore from "data/NavigatorStore";
import TableStore from "data/TableStore";
import useFluxStore from "@armus/use-flux-store";
import AbstractionAiStore from "../../../../data/meta/AbstractionAiStore";

export class InnerSidebarLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openId: props.hasAbstractionAi ? null : "definitions",
        };
        this.toggleOpenId = this.toggleOpenId.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.activeFieldKey !== this.props.activeFieldKey) {
            this.setState({...this.state, openId: this.props.hasAbstractionAi ? null : "definitions"});
        }
    }

    render() {
        const {
            activeTabId,
            setActiveTabId,
            hasActiveRecord,
            hasAbstractionAi,
        } = this.props;
        const tabs = [];
        if (hasActiveRecord) {
            tabs.push(
            {
                id: "definitions",
                name: "Definitions" + (hasAbstractionAi ? " & Suggestions" : ""),
                class: "definitions",
                icon: "book"
            }, {
                id: "validation",
                name: "Validation",
                class: "validation",
                icon: "check-square-o"
            });
        }
        if (tabs.length === 0) return null;
        let actuallyActiveTabId = activeTabId;
        if (tabs.every(t => t.id !== activeTabId)) {
            actuallyActiveTabId = tabs[0].id;
        }
        return (
            <div className={"sidebar"}>
                <div className="navigation" key="tabs">
                    <NavTabs
                        tabs={tabs.map(t => ({
                            ...t,
                            active: t.id === actuallyActiveTabId,
                        }))}
                        doSelect={setActiveTabId}
                    />
                </div>
                <div className="sidebar_content" key="content">
                    <div>
                        {this.renderActive(actuallyActiveTabId)}
                    </div>
                </div>
            </div>
        );
    }

    toggleOpenId(id) {
        const {
            openId,
        } = this.state;
        const {
            hasAbstractionAi
        } = this.props;
        if(!hasAbstractionAi) {
            // don't do anything
            return;
        }
        if(openId === id) {
            id = null;
        }
        this.setState({...this.state, openId: id});
    }

    renderActive(activeTabId) {
        const {
            fluxContext,
            hasAbstractionAi,
        } = this.props;
        const {
            openId,
        } = this.state;
        switch (activeTabId) {
            case "definitions":
                return (
                    <React.Fragment>
                        <DataDefinitionsContainer
                            open={openId === null ? null : openId === "definitions"}
                            onToggleOpen={() => this.toggleOpenId("definitions")}
                            fluxContext={fluxContext}
                        />
                        {hasAbstractionAi && <AbstractionAi
                            open={openId === null ? null : openId === "abstractionai"}
                            onToggleOpen={() => this.toggleOpenId("abstractionai")}
                            fluxContext={fluxContext}
                        />}
                    </React.Fragment>
                );
            case "validation":
                return <ValidationTree fluxContext={fluxContext} />;
            default:
                console.log("tab", activeTabId);
                return;
        }
    }

}

InnerSidebarLayout.propTypes = {
    activeTabId: PropTypes.string.isRequired,
    activeFieldKey: PropTypes.string,
    setActiveTabId: PropTypes.func.isRequired,
    hasActiveRecord: PropTypes.bool.isRequired,
    hasAbstractionAi: PropTypes.bool.isRequired,
    fluxContext: PropTypes.string.isRequired,
};

const SidebarLayout = props => {
    const { fluxContext } = props;
    const ctrl = ActiveFormStore.getActiveControl(fluxContext);
    const fieldKey = ctrl == null ? null : ctrl.fieldKey;
    const state = useFluxStore(() => ({
            fluxContext,
            hasActiveRecord: NavigatorStore.getRecordState(fluxContext) != null,
            hasAbstractionAi: AbstractionAiStore.canAISuggestion(fluxContext),
            activeTabId: ActiveFormStore.getActiveSidebarTab(fluxContext),
            activeFieldKey: fieldKey,
            setActiveTabId: id => Dispatcher.contextDispatch(fluxContext, {
                type: ActiveFormActions.SELECT_SIDEBAR_TAB,
                id,
            }),
        }), [
        ActiveFormStore,
        NavigatorStore,
        TableStore
    ], [fluxContext, fieldKey]);
    return <InnerSidebarLayout {...props} {...state} />;
};

SidebarLayout.propTypes = {
    fluxContext: PropTypes.string.isRequired
};

export default SidebarLayout;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/sidebar/SidebarLayout.js